import { Injectable } from '@angular/core';
import * as rutHelpers from 'rut-helpers';

@Injectable({
  providedIn: 'root'
})
export class RutService {

  rutTrans(rut) {
    rut = rutHelpers.rutClean(rut);
    rut = rutHelpers.rutFormat(rut);
    return rut;
  }
}
